import React from "react";
import makeCls from "../../../app/editor/utils/makeCls";

export default React.forwardRef(
    function Grid({as, children, className, col, revert, full, nowrap, space, justify, items, ...props}, ref) {
        const Tag = as || 'div';
        return (
            // @ts-ignore
            <Tag ref={ref} className={makeCls([
                'flex',
                className,
                col && !revert && 'flex-col',
                col && revert && 'flex-col-reverse',
                !col && revert && 'flex-row-reverse',
                full && !col && 'w-full',
                full && col && 'h-full',
                nowrap ? 'flex-nowrap' : 'flex-wrap',
                space === 'x2s' && (col ? 'space-y-0.5' : 'space-x-0.5'),
                space === 'xs' && (col ? 'space-y-1' : 'space-x-1'),
                space === 's' && (col ? 'space-y-2' : 'space-x-2'),
                space === 'm' && (col ? 'space-y-4' : 'space-x-4'),
                // Items
                items === 'start' && 'items-start',
                items === 'end' && 'items-end',
                items === 'center' && 'items-center',
                // Justify
                justify === 'start' && 'justify-start',
                justify === 'end' && 'justify-end',
                justify === 'center' && 'justify-center',
                justify === 'between' && 'justify-between',
            ])} {...props}>
                {children}
            </Tag>
        );
    }
);
